"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionImporter = void 0;
var section_1 = require("../../../core/model/section/section");
var section_properties_1 = require("../../../core/model/section/section-properties");
var SectionImporter = (function () {
    function SectionImporter(data) {
        this.data = data;
        this.createSection();
    }
    SectionImporter.prototype.insertSection = function () {
        this.data.subDocumentInfo.paragraphImporter.insertParagraph(true);
        this.finishSection();
        this.createSection();
    };
    SectionImporter.prototype.finishSection = function () {
        this.section.setLength(this.data.subDocument, this.data.subDocumentInfo.positionImporter.currPosition - this.section.startLogPosition.value);
    };
    SectionImporter.prototype.createSection = function () {
        this.properties = this.getDefaultSectionProperties();
        this.section = new section_1.Section(this.data.documentModel, this.data.subDocument.positionManager.registerPosition(this.data.subDocumentInfo.positionImporter.currPosition), 0, this.properties);
        var sectionCount = this.data.documentModel.sections.length;
        if (sectionCount > 0) {
            var prevSection = this.data.documentModel.sections[sectionCount - 1];
            this.section.headers.copyFrom(prevSection.headers);
            this.section.footers.copyFrom(prevSection.footers);
        }
        this.data.documentModel.sections.push(this.section);
    };
    SectionImporter.prototype.getDefaultSectionProperties = function () {
        return new section_properties_1.SectionProperties();
    };
    return SectionImporter;
}());
exports.SectionImporter = SectionImporter;
